import { HttpErrorResponse } from '@angular/common/http';

/**
 * Error thrown by the aggregate interceptor. It keeps the plain `Error` shape existing callers rely on,
 * but also carries the HTTP status and response body so callers can show the backend's reason.
 */
export interface PreservedHttpError extends Error {
  status?: number;
  error?: any;
}

export function toPreservedError(error: HttpErrorResponse): PreservedHttpError {
  const preserved: PreservedHttpError = new Error(error?.message);
  preserved.status = error?.status;
  preserved.error = error?.error;
  return preserved;
}
